<template>
  <EntityListDisplay
      :items="logs"
      :columns="logColumns"
      :hasActions="false"
      :onlyList="true"
  >
    <template #card="{ item }">
      <div class="user-card-header">
        <div class="avatar-3d">
          <i class="material-icons">history</i>
        </div>
        <div class="user-card-title">
          <span class="user-name">{{ item.user ? item.user.email : 'Sistema' }}</span>
          <span class="user-group">{{ formatDate(item.date) }}</span>
        </div>
      </div>
      <div class="user-card-body">
        <div class="user-info"><i class="material-icons">description</i> {{ item.action }}</div>
        <div class="user-info"><i class="material-icons">info</i> {{ item.module }}</div>
          <div class="user-card-actions mt-2">
            <button v-if="canViewLogs" class="btn btn-info p-1 ms-1 shadow-3d" title="Ver detalles de la traza" @click.stop="viewLog && viewLog(item)"><i class="material-icons">visibility</i></button>
          </div>
      </div>
    </template>
    <template #title>
      Trazas del Sistema
    </template>
  </EntityListDisplay>
</template>

<script>
import {mapGetters} from 'vuex';
import EntityListDisplay from "@/components/EntityListDisplay.vue";
import {Permissions} from '@/utils/permissions';

export default {
  name: "List_Logs",
  components: { EntityListDisplay },
  data() {
    return {
      logColumns: [
        { key: "user", label: "Usuario", formatter: (value, item) => item.user ? item.user.email : "Sistema" },
        { key: "date", label: "Fecha", formatter: (value, item) => this.formatDate(item.date) },
        { key: "action", label: "Acción" },
        { key: "module", label: "Detalles" }
      ],
      logs: []
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
    canViewLogs() {
      return this.hasPermission(Permissions.SECURITY_TRACES_VIEW);
    }
  },
  methods: {
    async fetchLogs() {
      const { logs } = await import("@/actions");
      const resLogs = await logs();
      this.logs = resLogs.data.data.traces || [];
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleString();
    }
  },
  mounted() {
    this.fetchLogs();
  }
}
</script>

<style scoped>
.btn-new-user {
  font-size: 1.1rem;
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(2, 33, 38, 0.08);
  background: linear-gradient(90deg, #3A9F1D 0%, #5fe939 100%);
  color: #fff;
  font-weight: bold;
  transition: background 0.2s;
}

.btn-new-user:hover {
  background: linear-gradient(90deg, #5fe939 0%, #3A9F1D 100%);
  color: #fff;
}

.modal {
  /* Spinner global */

  .site-spinner {
    width: 60px;
    height: 60px;
    border: 7px solid #e0e0e0;
    border-top: 7px solid #3A9F1D;
    border-right: 7px solid #5fe939;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 15px;
  width: 50%;
}

.modal {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.modal.show {
  opacity: 1;
}

@media (max-width: 550px) {
  .modal-content {
    width: 90%;
    margin-top: 20%;
  }
}

.user-card .card-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
}

.user-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.1rem;
}

.avatar-3d {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3A9F1D 0%, #5fe939 100%);
  box-shadow: 0 4px 16px #3A9F1D44, 0 1px 0 #5fe939 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.2rem;
  margin-right: 1.1rem;
}

.user-card-title {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: bold;
  font-size: 1.18rem;
  color: #2a4d1b;
  text-shadow: 0 1px 0 #fff;
}

.user-group {
  font-size: 0.98rem;
  color: #5fe939;
  font-weight: 500;
  margin-top: 2px;
}

.user-card-body {
  margin-bottom: 1.1rem;
}

.user-info {
  display: flex;
  align-items: center;
  font-size: 1.04rem;
  color: #3A9F1D;
  margin-bottom: 0.4rem;
}

.user-info i {
  font-size: 1.1rem;
  margin-right: 0.5rem;
  color: #5fe939;
}
</style>
